var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo26(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    d: "M.259.259h79.482v79.483H.259z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M73.236 60.785c-.582-3.626-2.946-6.672-9.95-9.512-2.433-1.118-5.146-1.919-5.954-3.763-.287-1.073-.325-1.677-.143-2.327.52-2.107 3.037-2.765 5.031-2.16 1.285.43 2.5 1.42 3.234 3 3.43-2.222 3.423-2.207 5.818-3.733-.877-1.36-1.345-1.987-1.919-2.569-2.063-2.304-4.874-3.49-9.369-3.4l-2.341.303c-2.244.567-4.383 1.745-5.637 3.324-3.762 4.27-2.69 11.74 1.89 14.816 4.51 3.385 11.136 4.155 11.982 7.321.824 3.876-2.848 5.13-6.498 4.685-2.69-.56-4.185-1.927-5.802-4.413C50.6 64.08 50.6 64.08 47.54 65.84c.726 1.587 1.488 2.305 2.705 3.68 5.757 5.84 20.165 5.552 22.749-3.287.105-.303.8-2.328.241-5.448zM43.468 36.789h-7.434l-.03 19.22c0 4.088.21 7.835-.454 8.984-1.088 2.26-3.906 1.98-5.19 1.541-1.308-.643-1.973-1.556-2.743-2.848-.211-.37-.37-.657-.423-.68l-6.045 3.702c1.005 2.063 2.486 3.853 4.382 5.016 2.833 1.7 6.641 2.222 10.623 1.308 2.592-.755 4.828-2.319 5.999-4.7 1.693-3.12 1.33-6.897 1.314-11.075.038-6.816 0-13.63 0-20.468z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo26);
export default __webpack_public_path__ + "static/media/logo26.5460570efc4ab7eaf23086ded42da348.svg";
export { ForwardRef as ReactComponent };